/* eslint-disable no-param-reassign */
/* eslint-disable global-require, class-methods-use-this */

import counterpart from 'counterpart';
import languageList from '../utils/constants/languages';

export function initLanguage(language) {
  if (language === undefined) {
    language = 'en_us';
  }

  return language;
}

export function initCommonTranslate() {
  counterpart.registerTranslations('en-US', require('./translations/en-us.json'));
  counterpart.registerTranslations('en', require('./translations/en-us.json'));
}

/**
 * get all the translations needed to pass down to a GDReportRunner component from a container
 * @param  {Object} options  optional flags to customize the translations per page
 * @return {Object}          key-value pairs for translations
 */
export function getFileList() {
  return [
    {
      value: 'csv',
      text: 'CSV',
    },
    {
      value: 'pdf',
      text: 'PDF',
    },
  ];
}

export function getBrowserDefaultLanguage(browserLanguage) {
  const ENGLISH = 0;
  const ENGLISH_UK = 1;
  const ENGLISH_CA = 2;
  const FRENCH_CA = 3;
  const TRADITIONAL_CHINESE = 4;
  const SIMPLIFIED_CHIENESE = 5;

  switch (browserLanguage.toLowerCase()) {
    case 'en-us':
      return languageList[ENGLISH];
    case 'en-gb':
      return languageList[ENGLISH_UK];
    case 'en-ca':
      return languageList[ENGLISH_CA];
    case 'fr-ca':
      return languageList[FRENCH_CA];
    case 'zh-cn':
      return languageList[SIMPLIFIED_CHIENESE];
    case 'zh-tw':
      return languageList[TRADITIONAL_CHINESE];
    default:
      return languageList[ENGLISH];
  }
}
export function getHierarchySelectorTranslations() {
  return {
    apply: counterpart('globalTranslate.hierarchySelector.apply'),
    availableItems: counterpart('globalTranslate.hierarchySelector.availableItems'),
    browseAllItems: counterpart('globalTranslate.hierarchySelector.browseAllItems'),
    cancel: counterpart('globalTranslate.hierarchySelector.cancel'),
    clearAll: counterpart('globalTranslate.hierarchySelector.clearAll'),
    clearSelected: counterpart('globalTranslate.hierarchySelector.clearSelected'),
    createSavedSelection: counterpart('globalTranslate.hierarchySelector.createSavedSelection'),
    currentSelected: counterpart('globalTranslate.hierarchySelector.currentSelected'),
    itemsTitle: counterpart('globalTranslate.hierarchySelector.itemsTitle'),
    moreThan30Selections: counterpart('globalTranslate.hierarchySelector.moreThan30Selections'),
    name: counterpart('globalTranslate.hierarchySelector.name'),
    none: counterpart('globalTranslate.hierarchySelector.none'),
    noSavedSelections: counterpart('globalTranslate.hierarchySelector.noSavedSelections'),
    pluralText: counterpart('globalTranslate.hierarchySelector.pluralText'),
    refineByItem: counterpart('globalTranslate.hierarchySelector.refineByItem'),
    save: counterpart('globalTranslate.hierarchySelector.save'),
    savedSelections: counterpart('globalTranslate.hierarchySelector.savedSelections'),
    saveSelections: counterpart('globalTranslate.hierarchySelector.saveSelections'),
    selectAll: counterpart('globalTranslate.hierarchySelector.selectAll'),
    viewSelections: counterpart('globalTranslate.hierarchySelector.viewSelections'),
    checkedItems: counterpart('globalTranslate.hierarchySelector.checkedItems'),
  };
}

/**
 * get all the translations needed to pass down to components on the Reports list page
 * @return {Object}          key-value pairs for translations
 */
export function getReportListTranslations() {
  return {
    addAll: 'globalTranslate.common.addAll',
    availablePeople: 'globalTranslate.reports.availablePeople',
    create: 'globalTranslate.common.create',
    customReportBuilder: 'globalTranslate.reports.customReportBuilder',
    report: 'globalTranslate.reports.report',
    reports: 'globalTranslate.reports.reports',
    defaultReports: 'globalTranslate.reports.defaultReports',
    customReports: 'globalTranslate.reports.customReports',
    generatedReports: 'globalTranslate.reports.generatedReports',
    addSchedule: 'globalTranslate.reportScheduler.addSchedule',
    cancel: 'globalTranslate.reportBuilder.cancel',
    confirmReportDelete: 'globalTranslate.reportBuilder.confirmReportDelete',
    delete: 'globalTranslate.reportBuilder.delete',
    deleteReport: 'globalTranslate.reportBuilder.deleteReport',
    export: 'globalTranslate.common.export',
    editReport: 'globalTranslate.reports.editReport',
    exportReport: 'globalTranslate.reports.exportReport',
    exportTypesTitle: 'globalTranslate.common.exportTitle',
    fileNameLabel: 'globalTranslate.common.fileName',
    fileTypesTitle: 'globalTranslate.common.saveAs',
    selectSavedFilter: 'globalTranslate.scheduleManager.selectSavedFilter',
    header: 'globalTranslate.common.exportHeader',
    noCategory: 'globalTranslate.reports.noCategory',
    people: 'globalTranslate.reports.people',
    person: 'globalTranslate.reports.person',
    removeAll: 'globalTranslate.common.removeAll',
    reportSharedTitle: 'globalTranslate.reports.reportSharedTitle',
    reportOwner: 'globalTranslate.reports.reportOwner',
    wasSharedTitleFragment: 'globalTranslate.reports.wasSharedTitleFragment',
    reportSharedDescription1: 'globalTranslate.reports.reportSharedDescription1',
    scheduleReport: 'globalTranslate.reportScheduler.scheduleReport',
    searchByNameOrEmail: 'globalTranslate.reports.searchByNameOrEmail',
    searchReportName: 'globalTranslate.reports.searchReportName',
    selectedUsers: 'globalTranslate.reports.selectedUsers',
    share: 'globalTranslate.reports.share',
    sharedList: 'globalTranslate.reports.sharedList',
    stopSharing: 'globalTranslate.reports.stopSharing',
    sharedWith: 'globalTranslate.reports.sharedWith',
    shareReport: 'globalTranslate.reports.shareReport',
    viewReport: 'globalTranslate.reports.viewReport',
    download: 'globalTranslate.reports.download',
    myReports: 'globalTranslate.common.myReports',
    sharedWithMe: 'globalTranslate.common.sharedWithMe',
    new: 'globalTranslate.reports.new',
    draft: 'globalTranslate.reports.draft',
    more: 'globalTranslate.reports.more',
    noGeneratedReportsHeading: 'globalTranslate.reports.noGeneratedReportsHeading',
    noGeneratedReportsDescription: 'globalTranslate.reports.noGeneratedReportsDescription',
    errorDownloadingFile: 'globalTranslate.reports.errorDownloadingFile',
    emptySavedFilter: {
      title: 'globalTranslate.reports.savedFilterIsRequired',
      subTitle: 'globalTranslate.reports.dontHaveSavedFilters',
    },
  };
}

export function getLanguageCode(languageAbbr){
  switch(languageAbbr){
    case 'EN' :
      return 'en-US';
    case 'CE' :
      return 'en-CA';
    case'UK' :
      return 'en-GB';
    case 'ES' :
      return 'es-MX';
    case 'FC' :
      return 'fr-CA';
    case 'SC' :
      return 'zh-CN';
    case 'TC' :
      return 'zh-HK';
    default :
      return 'EN';

  }
}

export default {
  initLanguage,
  initCommonTranslate,
  getFileList,
  getBrowserDefaultLanguage,
  getHierarchySelectorTranslations,
  getReportListTranslations,
  getLanguageCode,
};
